import { render, staticRenderFns } from "./ShareToB.vue?vue&type=template&id=2dff3efa&scoped=true&"
import script from "./ShareToB.vue?vue&type=script&lang=js&"
export * from "./ShareToB.vue?vue&type=script&lang=js&"
import style0 from "./ShareToB.vue?vue&type=style&index=0&id=2dff3efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff3efa",
  null
  
)

export default component.exports